export const data = () => ({
  isDebug: true,
  loading: false,
  violationID: 0,
  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
